import BaseModel from '@/app-core/lib/data/model/BaseModel'
import CustomerValidator from '@/app-core/api/validations/customer/CustomerValidator'
import CustomerResource from '@/app-core/api/resources/customer/CustomerResource'
import API from '@/app-core/api/Api'

export default class CustomerModel extends BaseModel {
  constructor(payload = {}, resource = CustomerResource, validator = CustomerValidator) {
    super(payload, resource, validator)
  }

  /* PROPERTIES */

  boot() {
    super.boot()

    this.guarded = []
  }

  /* METHODS */
  async AuthStatus() {
    return await API.Resource.User.AuthStatus()
  }
}
